import DiagramType from "../../../../../../logic/components/Diagram/DiagramType";
import type NodeTransformerFunc from "../../../../core/edit/logic/Prosemirror/NodeTransformerFunc";
import getFencedDiagramAttrs from "../getFencedDiagramAttrs";
import isDiagramName from "../isDiagramName";
import isFenceDiagramLang from "../isFenceDiagramLang";

const diagramsNodeTransformer: NodeTransformerFunc = (node) => {
	if (node?.type === "code_block" && isFenceDiagramLang(node?.attrs?.language)) {
		const fenced = {
			type: "diagrams",
			attrs: {
				...getFencedDiagramAttrs(node.attrs.language, node.content?.[0]?.text ?? ""),
				...(node.attrs.comment?.id && { comment: node.attrs.comment }),
			},
		};
		return { isSet: true, value: fenced };
	}
	if (isDiagramName(node?.type)) {
		const tagged = {
			type: "diagrams",
			attrs: {
				...node.attrs,
				diagramName: DiagramType[node.type],
			},
		};
		return { isSet: true, value: tagged };
	}

	return null;
};

export default diagramsNodeTransformer;
